// Who pays: the Coop of each order, always.
export const isCoopParty = (mill) => mill?.kind === "coop";

function contextOrders(context) {
  return [...(context?.links || []), ...(context?.visits || []).flatMap((visit) => visit.orders || [])];
}

// Clients names (live data) of the Coop parties of an object's orders.
export function coopPartyNames(context) {
  const names = new Map();
  for (const order of contextOrders(context)) {
    const party = order?.coop_party;
    if (party?.id && party.display_name) names.set(party.id, party.display_name);
  }
  return names;
}

export function billedPartyLabel(mill, names = null) {
  return names?.get(mill?.id) || mill?.display_name || mill?.name || "Facturer à non renseigné";
}

// « Facturé à » of a visit: the Coop names of its orders; an order without Coop is missing.
export function visitBilledParties(visit) {
  const names = [];
  const missing = [];
  for (const order of visit?.orders || []) {
    // « aucun », un nom inconnu ou une entreprise supprimée ne désignent aucune entreprise facturée.
    if (order.coop && order.coop_valid !== false) names.push(order.coop_party?.display_name || order.coop);
    else missing.push(order.label);
  }
  return { names: [...new Set(names)], missing };
}
